"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.classesPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var classesPropType = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]);
exports.classesPropType = classesPropType;